import RegDevTools from './reg-dev-tools';

export default RegDevTools;
